import { Link } from "react-router-dom";
import logo from './logo-web.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
        L’appli des petits génies des maths
        </p>
        <Link
          className="App-link-simple"
          to="https://testflight.apple.com/join/4phY4rdR"
        >
          IOS application
        </Link>
        <Link
          className="App-link-simple"
          to="https://gigan.fr/mathemakids.apk"
        >
          Android application
        </Link>
        <Link
          className="App-link"
          to="/privacy-policy"
        >
          Engagement de confidentialité
        </Link>
      </header>
    </div>
  );
}

export default App;
